module.exports = __webpack_public_path__ + "img/avatar-s-2.fc2135e1.jpg";